export default {
	LIGHT_MODE: 'light',
	SPACE_MODE: 'space',
};
